<template>
    <div class="wizard">
        <form-wizard title="" subtitle="" step-size="xs" ref="wizard">
            <tab-content title="" :additional-info="{progress: false}" class="wizard-tab-container--intro">
                <template slot="default">
                    <section class="intro">
                        <div class="intro__col1">
                            <h1 class="title title--h1">Nechte si vystavit vyúčtování<br>
                                za vodu trochu jinak.</h1>
                            <p class="intro__text">Odpovězte na několik otázek a zjistěte, jaká je vaše vodní stopa.<br>
                                Svůj výsledek uvidíte v porovnání se zbytkem republiky.
                            </p>
                            <button @click="wizard.nextTab()" class="btn btn--large intro__btn">Jdeme na to</button>
                        </div>
                        <div class="intro__col2">
                            <img :src="illustrations.file" alt="" class="intro__img">
                        </div>
                    </section>
                </template>
            </tab-content>
            <tab-content title="" :additional-info="{progress: false}" class="wizard-tab-container--wide">
                <section class="checkpoint">
                    <h3 class="title title--h3">Pokud nenajdete úplně přesnou odpověď, vyberte prostě tu, která se nejvíc blíží skutečnosti.</h3>
                    <h3 class="title title--h3">Začneme zlehka.</h3>
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  text="Tak jo. Můžem dál"
                                  :no-mt="true"
                                  v-if="wizard"></GroheNavBtns>
                </section>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q1')"
                         :additional-info="{progress: true}" class="wizard-tab-container--wide">
                <GroheRadios
                    :items="[
                        {text: 'Ano, je to super věc!', value: true},
                        {text: 'Zatím ne.', value: false}
                    ]"
                    :no-value="true"
                    ref="q1"
                    name="q1"
                    title="Máte kohoutek s perlátorem?"
                    :animation="animations.perlator"
                    question-number="1"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard" class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q2')"
                         :additional-info="{progress: true}" class="wizard-tab-container--wide">
                <GroheRange
                    ref="q2"
                    name="q2"
                    :min="0"
                    :max="30"
                    title="Necháváte během čištění zubů nebo holení téct vodu?"
                    subtitle="Zkuste odhadnout, jak dlouho (za celý den)..."
                    unit="minut"
                    :value-per-unit="currentValues['q1'] ? 5 : 10"
                    question-number="2"
                    :animation="animations.zub"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRange>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q3')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Jasná věc.', value: true},
                        {text: 'Nejspíš ne.', value: false}
                    ]"
                    :no-value="true"
                    ref="q3"
                    name="q3"
                    title="Máte sprchovou hlavici, která šetří vodu?"
                    question-number="3"
                    :animation="animations.sprcha"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q4')"
                         :additional-info="{progress: true}">
                <GroheRange
                    ref="q4"
                    name="q4"
                    :min="0"
                    :max="30"
                    title="Rádi si ve sprše zazpíváte, nebo jste hned venku?"
                    subtitle="Sprcha mi zabere…"
                    unit="minut"
                    :value-per-unit="currentValues['q3'] ? 9 : 18"
                    question-number="4"
                    :animation="animations.noty"
                    @on-validate="updateValues"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRange>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q5')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q5"
                    name="q5"
                    title="Relaxujete někdy ve vaně? Jak často?"
                    unit="krát"
                    :value-per-unit="150"
                    question-number="5"
                    :animation="animations.vana"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q6')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Ano, má a používám obě tlačítka.', value: 14},
                        {text: 'Má, ale stejně splachuju jen jedním tlačítkem.', value: 30},
                        {text: 'Nemá, tahám za špagátek.', value: 30},
                        {text: 'Mám suchý záchod na zahradě.', value: 30},
                    ]"
                    ref="q6"
                    name="q6"
                    title="Má vaše WC duální splachování pro výběr mezi malým a větším množstvím vody?"
                    question-number="6"
                    :animation="animations.toaleta"
                    @on-validate="updateValues"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :additional-info="{progress: true}" :before-change="()=>validateStep('q7')">
                <GroheExpandingRadios
                    :items="[
                        {text: 'V ruce pěkně po staru.', value: 10},
                        {text: 'Mám na to myčku, ale není nejnovější.', value: 10},
                        {text: 'Mám myčku, která šetří vodu i energii.', value: 6},
                        {text: 'Kupuju si jen jídlo s sebou, takže nádobí neřeším.', value: 0, hideControls: true},
                    ]"
                    ref="q7"
                    name="q7"
                    title="Myjete nádobí v ruce nebo v myčce? Kolikrát denně?"
                    subtitle="Můžete vybrat více možností."
                    unit="krát"
                    :value-per-unit="1"
                    question-number="7"
                    @on-validate="updateValues"></GroheExpandingRadios>
                <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"></GroheNavBtns>
            </tab-content>
            <tab-content title="" :additional-info="{progress: true}" :before-change="()=>validateStep('q8')">
                <GroheExpandingRadios
                    :items="[
                        {text: 'Mám valchu po prababičce.', value: 1},
                        {text: 'V pračce, která už něco pamatuje.', value: 2.25},
                        {text: 'V nové pračce, která šetří vodu i energii.', value: 1},
                        {text: 'Dávám věci jen do čistírny.', value: 1.25},
                        {text: 'Chodím do laundromatu.', value: 2}
                    ]"
                    ref="q8"
                    name="q8"
                    title="Jak často a jakým způsobem perete prádlo?"
                    subtitle="Můžete vybrat více možností."
                    unit="krát"
                    :value-per-unit="8.5"
                    question-number="8"
                    @on-validate="updateValues"></GroheExpandingRadios>
                <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"></GroheNavBtns>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q9')"
                         :additional-info="{progress: true}">
                <GroheImageRadios
                    title="Máte nějaké pokojové rostliny?"
                    ref="q9"
                    name="q9"
                    question-number="9"
                    :items="[
                        {text: 'Ne, nevydrží mi ani kaktus.', value: 0.28, img: illustrations.cactus},
                        {text: 'Ano, mám doma džungli.', value: 1.14, img: illustrations.jungle},
                    ]"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--pb"></GroheNavBtns>
                </GroheImageRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q10')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Ne, nemám totiž zahradu.', value: false},
                        {text: 'Ano, zalévám z toho, co naprší do barelu.', value: false},
                        {text: 'Ne, zalévám hadicí z kohoutku.', value: true}
                    ]"
                    :no-value="true"
                    ref="q10"
                    name="q10"
                    title="Používáte na zalévání zahrady dešťovou vodu?"
                    question-number="10"
                    :animation="animations.konev"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q11')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q11"
                    name="q11"
                    title="Jak dlouho vám to tak zabere?"
                    unit="minut"
                    :value-per-unit="14"
                    question-number="11"
                    :animation="animations.konev"
                    @on-validate="updateValues"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q12')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Ano, mám.', value: true},
                        {text: 'Kdo v dnešní době potřebuje vlastní auto?', value: false}
                    ]"
                    :no-value="true"
                    ref="q12"
                    name="q12"
                    title="Máte auto?"
                    question-number="12"
                    :animation="animations.garaz"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q13')"
                         :additional-info="{progress: true}" >
                <GroheExpandingRadios
                    :items="[
                        {text: 'Ručně s kýblem a houbou.', value: 50},
                        {text: 'Ručně hadicí.', value: 400},
                        {text: 'Jezdím s ním do myčky.', value: 400},
                        {text: 'Neřeším, nechávám to opršet.', value: 0, hideControls: true},
                    ]"
                    ref="q13"
                    name="q13"
                    title="Jak často ho myjete a kde?"
                    question-number="13"
                    unit="krát"
                    :value-per-unit="1"
                    @on-validate="updateValues"
                >
                </GroheExpandingRadios>
                <GroheNavBtns :next="wizard.nextTab"
                              :prev="wizard.prevTab"
                              v-if="wizard"></GroheNavBtns>
            </tab-content>
            <tab-content title="" :additional-info="{progress: false}" class="wizard-tab-container--wide">
                <section class="checkpoint">
                    <h3 class="title title--h3">Jde vám to skvěle!</h3>
                    <h3 class="title title--h3">Už zbývá jen posledních pár otázek, které řeší vaši nepřímou spotřebu vody. Ta má totiž na vodní stopu taky velký vliv.</h3>
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  text="OK. Sem s nimi"
                                  :no-mt="true"
                                  v-if="wizard"></GroheNavBtns>
                </section>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q14')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Benzín', value: false},
                        {text: 'Naftu', value: true}
                    ]"
                    :no-value="true"
                    ref="q14"
                    name="q14"
                    title="Tankujete benzín, nebo naftu?"
                    question-number="14"
                    @on-validate="updateValues"></GroheRadios>
                <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"></GroheNavBtns>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q15')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q15"
                    name="q15"
                    title="Kolik km najedete v autě?"
                    unit="km"
                    :value-per-unit="currentValues['q14'] ? 0.36 : 0.69"
                    question-number="15"
                    :animation="animations.meter"
                    @on-validate="updateValues"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q16')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Ano, jezdím.', value: true},
                        {text: 'Nikdy nejezdím hromadnou dopravou.', value: false}
                    ]"
                    :no-value="true"
                    ref="q16"
                    name="q16"
                    title="Jezdíte někdy hromadnou dopravou?"
                    question-number="16"
                    :animation="animations.vlak"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :additional-info="{progress: true}" :before-change="()=>validateStep('q17')">
                <GroheExpandingRadios
                    :items="[
                        {text: 'Městská doprava:', value: 0.06},
                        {text: 'Příměstská doprava:', value: 0.22},
                    ]"
                    ref="q17"
                    name="q17"
                    title="Kolik tak najezdíte km?"
                    unit="km"
                    :value-per-unit="1"
                    question-number="17"
                    @on-validate="updateValues"></GroheExpandingRadios>
                <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"></GroheNavBtns>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q18')"
                         :additional-info="{progress: true}">
                <GroheRadios
                    :items="[
                        {text: 'Nesnáším nakupování.', value: 2},
                        {text: 'Nakupuju, jen když něco fakt potřebuju.', value: 8},
                        {text: 'Oblečení mě baví, kupuju si ho víc, ale nepřeháním to.', value: 18},
                        {text: 'Jsem shopaholik a žádné novince neodolám.', value: 28}
                    ]"
                    ref="q18"
                    name="q18"
                    title="Jak často si kupujete nové oblečení?"
                    question-number="18"
                    :animation="animations.nakup"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q19')"
                         :additional-info="{progress: true}">
                <GroheImageRadios
                    title="Jak byste popsali svůj jídelníček?"
                    ref="q19"
                    name="q19"
                    question-number="19"
                    :items="[
                        {text: 'Vegan', value: 2563, img: illustrations.vegan},
                        {text: 'Vegetarián', value: 2842, img: illustrations.vegetarian},
                        {text: 'Masožravec', value: 2500, img: illustrations.omni},
                    ]"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--pb"></GroheNavBtns>
                </GroheImageRadios>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q20')"
                         :additional-info="{progress: true}">
                <GroheNumber
                    title="Kolik masa sníte za týden?"
                    unit="kg"
                    name="q20"
                    ref="q20"
                    :value-per-unit="924"
                    @on-validate="updateValues"
                    question-number="20"
                    :increment=".5"
                    :animation="animations.kura">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheNumber>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q21')"
                         :additional-info="{progress: true}">
                <GroheNumber
                    title="Kolik českého ovoce sníte za týden?"
                    unit="kg"
                    name="q21"
                    ref="q21"
                    :value-per-unit="21.4"
                    question-number="21"
                    :increment=".5"
                    :animation="illustrations.fruit"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheNumber>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q22')"
                         :additional-info="{progress: true}">
                <GroheNumber
                    title="Kolik exotického ovoce sníte za týden?"
                    unit="kg"
                    name="q22"
                    ref="q22"
                    :value-per-unit="15.2"
                    @on-validate="updateValues"
                    question-number="22"
                    :increment=".5"
                    :animation="illustrations.fruitExotic">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheNumber>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q23')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q23"
                    name="q23"
                    title="Kolik půllitrů piva vypijete?"
                    unit="půllitrů"
                    :value-per-unit="148"
                    question-number="23"
                    @on-validate="updateValues"
                    :animation="animations.beer"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q24')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q24"
                    name="q24"
                    title="Kolik sklenic vína (2 dcl) vypijete?"
                    unit="sklenic"
                    :value-per-unit="176"
                    question-number="24"
                    :animation="illustrations.wine"
                    @on-validate="updateValues"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q25')"
                         :additional-info="{progress: true}">
                <GroheFrequency
                    ref="q25"
                    name="q25"
                    title="Kolik šálků kávy a čaje vypijete?"
                    unit="šálků"
                    :value-per-unit="27.78"
                    question-number="25"
                    @on-validate="updateValues"
                    :animation="animations.kava"
                >
                    <GroheNavBtns :next="wizard.nextTab"
                                  :prev="wizard.prevTab"
                                  v-if="wizard"
                                  class="wizard-nav-btns--left"></GroheNavBtns>
                </GroheFrequency>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('q26')"
                         :additional-info="{progress: true}">
                <GroheNumber
                    title="Jestli máte domácí mazlíčky, kolik krmiva zbaští za měsíc?"
                    unit="kg"
                    name="q26"
                    ref="q26"
                    :value-per-unit="0.01667"
                    :animation="animations.zradlo"
                    question-number="26"
                    @on-validate="updateValues">
                    <GroheNavBtns :next="wizard.nextTab" :prev="wizard.prevTab" v-if="wizard"
                                  class="wizard-nav-btns--left" text="Vyhodnocení"></GroheNavBtns>
                </GroheNumber>
            </tab-content>
            <tab-content title="" :additional-info="{progress: false}" class="wizard-tab-container--wide">
                <GroheResult
                    :current-total="currentTotal"
                    :survey-id="savedSurveyId"></GroheResult>
            </tab-content>
            <template slot="footer" slot-scope="props">
                <GroheCounter :number="currentTotal" v-if="showProgressBar"></GroheCounter>
                <div v-if="showProgressBar" class="progress-bar">
                    <div class="progress-bar__info">{{ Math.floor(progressPercentage) }}% dokončeno</div>
                    <div class="progress-bar__inner">
                        <span class="progress-bar__bar" :style="`width: ${progressPercentage}%`">{{ `${progressPercentage}%` }}</span>
                    </div>
                </div>
                <div class="wizard-footer-right" v-if="wizard.activeTabIndex"></div>
            </template>
        </form-wizard>
    </div>
</template>

<script>
import GroheRadios from '@/components/GroheRadios';
import GroheExpandingRadios from "@/components/GroheExpandingRadios";
import GroheCounter from '@/components/GroheCounter';
import GroheRange from "@/components/GroheRange";
import GroheFrequency from "@/components/GroheFrequency";
import GroheNavBtns from "@/components/GroheNavBtns";
import GroheNumber from "@/components/GroheNumber";
import GroheImageRadios from "@/components/GroheImageRadios";
import GroheResult from "@/components/GroheResult";

export default {
    name: 'App',
    components: {
        GroheResult,
        GroheRange,
        GroheRadios,
        GroheCounter,
        GroheFrequency,
        GroheExpandingRadios,
        GroheNavBtns,
        GroheNumber,
        GroheImageRadios
    },
    data: () => ({
        currentValues: {},
        isMounted: false,
        contact: null,
        publicPath: process.env.BASE_URL,
        savedSurveyId: null,
        animations: {
            beer: require("@/assets/animations/beer.json"),
            benzin: require("@/assets/animations/benzin.json"),
            garaz: require("@/assets/animations/garaz.json"),
            kaktus: require("@/assets/animations/kaktus.json"),
            kava: require("@/assets/animations/kava.json"),
            konev: require("@/assets/animations/konev.json"),
            kura: require("@/assets/animations/kura.json"),
            kvety: require("@/assets/animations/kvety.json"),
            meter: require("@/assets/animations/meter.json"),
            mycka: require("@/assets/animations/mycka.json"),
            nakup: require("@/assets/animations/nakup.json"),
            noty: require("@/assets/animations/noty.json"),
            perlator: require("@/assets/animations/perlator.json"),
            sprcha: require("@/assets/animations/sprcha.json"),
            toaleta: require("@/assets/animations/toaleta.json"),
            vana: require("@/assets/animations/vana.json"),
            vlak: require("@/assets/animations/vlak.json"),
            zradlo: require("@/assets/animations/zradlo.json"),
            zub: require("@/assets/animations/zub.json"),
        },
        illustrations: {
            vegan: require("@/assets/illustrations/vegan.svg"),
            vegetarian: require("@/assets/illustrations/vegetarian.svg"),
            omni: require("@/assets/illustrations/omni.svg"),
            cactus: require("@/assets/illustrations/cactus.svg"),
            jungle: require("@/assets/illustrations/jungle.svg"),
            file: require("@/assets/illustrations/file.svg"),
            wine: require("@/assets/illustrations/wine.svg"),
            fruit: require("@/assets/illustrations/fruit.svg"),
            fruitExotic: require("@/assets/illustrations/fruit-exotic.svg"),
        }
    }),
    methods: {
        validateStep(name) {
            const refToValidate = this.$refs[name];
            return refToValidate.validate();
        },
        updateValues(isValid, name, value) {
            if (isValid) {
                if (name === 'contact') return this.contact = value;
                this.$set(this.currentValues, name, value);
            }
        },
    },
    computed: {
        currentTotal() {
            return Object.values(this.currentValues).reduce((accum, curr) => {
                if (typeof curr === 'boolean') return accum
                return accum += curr
            }, 0);
        },
        wizard() {
            if (!this.isMounted) return false;
            return this.$refs['wizard'];
        },
        showProgressBar() {
            if (!this.wizard) return false;
            return this.wizard.tabs[this.wizard.activeTabIndex].additionalInfo.progress;
        },
        progressPercentage() {
            if (this.wizard) return ((this.wizard.activeTabIndex - 1) / (this.wizard.tabCount - 2)) * 100;
            return false;
        },
        index() {
            return this.wizard.activeTabIndex
        }
    },
    watch: {
        index(newVal, oldVal) {
            const wateringGarden = ('q10' in this.currentValues) && this.currentValues['q10'];
            const hasCar = ('q12' in this.currentValues) && this.currentValues['q12'];
            const pubTran = ('q16' in this.currentValues) && this.currentValues['q16'];
            const isMeatless = ('q19' in this.currentValues) && this.currentValues['q19'] !== 2500;
            // magic numbers
            if (!wateringGarden) {
                const wateringGardenIndex = 12;
                if (newVal === wateringGardenIndex && newVal > oldVal) this.wizard.changeTab(wateringGardenIndex, wateringGardenIndex + 1);
                if (newVal === wateringGardenIndex && newVal < oldVal) this.wizard.changeTab(wateringGardenIndex + 1, wateringGardenIndex - 1);
            }
            if (!hasCar) {
                const carIndex = 14;
                if (newVal === carIndex && newVal > oldVal) this.wizard.changeTab(carIndex, carIndex + 4);
                if (newVal === carIndex + 3 && newVal < oldVal) this.wizard.changeTab(carIndex + 3, carIndex - 1);
            }
            if (!pubTran) {
                const pubTranIndex = 19;
                if (newVal === pubTranIndex && newVal > oldVal) this.wizard.changeTab(pubTranIndex, pubTranIndex + 1);
                if (newVal === pubTranIndex && newVal < oldVal) this.wizard.changeTab(pubTranIndex + 1, pubTranIndex - 1);
            }
            if (isMeatless) {
                const isMeatlessIndex = 22;
                if (newVal === isMeatlessIndex && newVal > oldVal) this.wizard.changeTab(isMeatlessIndex, isMeatlessIndex + 1);
                if (newVal === isMeatlessIndex && newVal < oldVal) this.wizard.changeTab(isMeatlessIndex + 1, isMeatlessIndex - 1);
            }
        }
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>

<style lang="scss">
body {
    margin: 0;
    padding: 0;
}
*,
*:before,
*:after {
    box-sizing: border-box;
}
.wizard {
    font-family: 'Linotype Univers Normal', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $crow-black-blue;
    font-size: 22px;
    background-color: $aliceblue;
    position: relative;
}
.wizard-header {
    display: none !important;
}
.wizard-btn--intro {
    background-color: rgb(231, 76, 60) !important;
    border-color: rgb(231, 76, 60) !important;
    color: white;
}
.wizard-navigation {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.vue-form-wizard {
    display: flex;
    flex-direction: column;
    padding: 20px !important;
    min-height: calc(100vh - 80px);
}
.wizard-tab-content {
    padding: 0 !important;
}
.wizard-card-footer {
    display: flex;
    align-items: center;
    padding: 0 !important;
    margin-top: auto;

    &:empty {
        display: none;
    }

    .wizard-footer-left {
        margin-right: auto;
    }
}
.wizard-nav {
    display: none !important;
}
.wizard-progress-with-circle {
    display: none;
}
.wizard-tab-container {
    max-width: 850px;
    margin: auto;
}
.wizard-tab-container--wide {
    max-width: 1200px;
}
.wizard-tab-container--intro {
    max-width: 1200px;
    width: 100%;
}
.wizard-tab-content {
    display: flex; // to avoid horizontal scroll when animating
    width: 100%;
    margin-bottom: 30px;
    .wizard-tab-container {
        width: 100%;
        display: block;
        animation: slideInLeft 0.3s;
    }
}
.wizard-nav-btns {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    &--pb {
        padding-bottom: 25px;
    }
    &--no-mt {
        margin-top: 0 !important;
    }
}
.wizard-nav-btn {
    margin: 0 8px;
}

@media screen and (min-width: $mq-sm) {
    .vue-form-wizard {
        padding: 40px !important;
    }
    .wizard-tab-content {
        margin-bottom: 0;
    }
}

@media screen and (min-width: $mq-md) {
    .wizard-nav-btns {
        margin-top: 50px;

        &--pb {
            padding-bottom: 0;
        }
    }
    .wizard-nav-btns--left {
        justify-content: flex-start;
        margin-left: -8px;
    }
    .wizard-tab-container--wide {
        padding: 0 50px;
    }
    .wizard-tab-container--intro {
        padding: 0 50px;
    }
}

@keyframes slideInLeft {
    from {
        transform: translate3d(-100%, 0, 0);
        visibility: visible;
    }

    to {
        transform: translate3d(0, 0, 0);
    }
}
</style>
